'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactIdSwiper = require('react-id-swiper');var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _Constants = require('./Constants');var _Constants2 = _interopRequireDefault(_Constants);

var _TabSellingProperties = require('./TabSellingProperties.scss');var styles = _interopRequireWildcard(_TabSellingProperties);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var SliderComments = function SliderComments(props) {
    var translate = props.translate('internationalExposure', 'sliderComments');
    var params = {
        slidesPerView: 1.8,
        spaceBetween: 10,
        pagination: { clickable: true },
        rebuildOnUpdate: true,
        breakpoints: {
            1580: {
                slidesPerView: 1.5 },

            800: {
                slidesPerView: 1.2 } } };




    var mappedItems = function mappedItems(item) {return (
            _react2.default.createElement('div', { className: styles.sliderWrapper },
                _react2.default.createElement('div', { className: styles.slider },
                    _react2.default.createElement('img', { src: item.photo, className: styles.sliderPhoto, alt: 'realtor' }),
                    _react2.default.createElement('div', { className: styles.infoSlider },
                        _react2.default.createElement('p', null, translate(item.region, 'name')),
                        _react2.default.createElement('img', { src: item.flag, alt: 'realtor' })),

                    _react2.default.createElement('div', { className: styles.sliderComment },
                        _react2.default.createElement('p', null,
                            translate(item.region, 'comment')),

                        _react2.default.createElement('p', null,
                            translate(item.region, 'link'))))));};






    return (
        _react2.default.createElement('div', { className: styles.containerSlider },
            _react2.default.createElement(_reactIdSwiper2.default,
                params,

                _Constants2.default.map(mappedItems))));



};

SliderComments.propTypes = {
    translate: _propTypes2.default.func };


var mapStateToProps = function mapStateToProps(state) {return {
        translate: (0, _reduxPagan.getLang)(state.lang, 'RealtorLanding', 'NavTabs') };};exports.default =


(0, _reactRedux.connect)(mapStateToProps)(SliderComments);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TabSellingProperties/SliderComments.js
// module id = 2893
// module chunks = 0